import React, { Component } from 'react'
import { Breadcrumb, BreadcrumbItem } from 'shards-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

export class BreadCrumbLayout extends Component {
    static propTypes = {
        initialName: PropTypes.string,
        textRoute: PropTypes.string,
    }

    render() {
        return (
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link to={{ pathname: '/applications/1' }}>Eitri-Apps</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    {this.props.textRoute}: {this.props.initialName}
                </BreadcrumbItem>
            </Breadcrumb>
        )
    }
}
